export const formatPrice = (value: number | string, rate = 1, fraction = 2) =>
  (
    (typeof value === 'number' ? value / 100 : parseFloat(value)) / rate
  ).toFixed(fraction);
